<template>
  <div class="root order-display">
    <h2>#{{ order.id }}</h2>

    <table>
      <tbody>
        <tr>
          <td>Costs</td>
          <td>$ {{ order.totalAmount }}</td>
        </tr>
        <tr>
          <td>{{ order.status === "pending" ? "Shipping" : "Shipped" }} To</td>
          <td>
            {{ order.deliveryAddress }}
          </td>
        </tr>
        <tr>
          <td>Ordered on</td>
          <td>
            {{ parseDate(order.createdAt) }} at
            {{ parseTime(order.createdAt) }}
          </td>
        </tr>
        <tr>
          <td>
            <p class="m-0 status" :class="order.status">
              {{ order.status }}
            </p>
          </td>
          <td>
            <button
              v-if="order.status === 'pending'"
              @click.prevent="gotoOrderPayment"
            >
              Pay For Order
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { months } from "@/utils/variables";

export default {
  name: "OrderDisplay",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  methods: {
    parseDate(date) {
      date = new Date(date);

      let y = date.getFullYear();
      let m = months[date.getMonth()];
      let dt = date.getDate();

      const time = `${m} ${dt}, ${y}`;
      return time;
    },
    parseTime(time) {
      time = new Date(time);

      let h = time.getHours();
      let m = time.getMinutes();

      let period = "am";
      if (h >= 12) {
        period = "pm";
        if (h > 12) {
          h -= 12;
        }
      } else if (h === 0) {
        h = "12";
      }
      if (m < 10) {
        m = `0${m}`;
      }

      return `${h}:${m} ${period}`;
    },

    gotoOrderPayment (e) {
      e.stopImmediatePropagation()

      this.$store.commit("Orders/setPlacedOrderID", this.order.id)
      this.$router.push({ name: "Checkout", params: { order: false } })
    }
  },
};
</script>

<style lang="scss" scoped>
.root {
  margin-bottom: 2rem;
  border-radius: 5px;

  h2 {
    margin-top: 0;
  }

  table {
    td {
      height: 30px;

      &:first-child {
        padding-left: 0;
      }
    }
  }
}

$status-pending-color: $orange;
$status-paid-color: $green;

$transparent-amount: 0.85;
$darken-amount: 20;
.status {
  display: block;
  width: max-content;
  padding: 0.75rem 1.25rem;
  border-radius: 3px;
  text-transform: uppercase;

  &.pending {
    color: darken($status-pending-color, $darken-amount);
    background-color: transparentize(
      $status-pending-color,
      $transparent-amount
    );
  }
  &.paid {
    color: darken($status-paid-color, $darken-amount);
    background-color: transparentize($status-paid-color, $transparent-amount);
  }
}
</style>
<style lang="scss">
$status-pending-color: $orange;
$status-paid-color: $green;

$lighten-amount: 5;
.theme-dark {
  .order-display {
    .status {
      &.pending {
        color: lighten($status-pending-color, $lighten-amount);
      }
      &.paid {
        color: lighten($status-paid-color, $lighten-amount);
      }
    }
  }
}
</style>